export default __webpack_public_path__ + "static/media/Blue Ocean.bedf4fdc.png";